import * as baseHistory from "history";

export const OGS_API_URL = process.env.OGS_API_URL;
export const WORDPRESS_URL = "https://www.opengamingsolutions.com/";
export const WORDPRESS_TOP_MENU_ID = 41;
export const WORDPRESS_BOTTOM_MENU_ID = 62;
export const BONUS_OUTCOME_NAME = "Keno Bonus";
export const DEFAULT_LOCALE = "EN_US";
export const DATE_FORMAT = "M/D/YY h:mm a";

export const OGS_LOGO_IMAGE = require("./images/ogs-logo.png");

/**
 * ROUTER HISTORY
 * Which form of history to use for the router, out of the box supports:
 * - "createBrowserHistory" to use slashes in the URL
 * - "createHashHistory" to use the hash symbol separator
 *
 * See: https://www.npmjs.com/package/history for more examples.
 */
export const history = baseHistory.createHashHistory({hashType: "slash"});



// WEBPACK FOOTER //
// ./src/settings.ts